<template>
  <b-card>
    <span
      v-if="cistList.length < 1"
      class="text-danger">No cars available for this station</span>
    <b-row
      v-for="cist in cistList"
      :key="cist.CODE"
      class="card-text mt-2">
      <b-col md="4">{{ cist.CAR_DETAIL.NAME }}</b-col>
      <b-col md="2">{{ cist.CAR_DETAIL.LICENSE_PLATE }}</b-col>
      <b-col md="3">
        <b-input
          :id="cist.CODE"
          :value="cist.ASSIGNMENT.NOTE"
          size="sm"
          @input.native="updateCarNote"/>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: 'CarView',
  props: {
    station: {
      type: Object,
      default: () => {}
    },
    cistList: {
      type: Array,
      default: () => []
    },
    assignments: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateCarNote (e) {
      this.$store.commit('assignment/carNoteUpdated', {stationCode: this.station.CODE, note: e.target.value, cistCode: e.target.id})
    }
  }
}
</script>
